import { combineReducers } from "@reduxjs/toolkit";

import credentialsSlice from "./credentials";
import spreadsheetSlice from "./spreadsheet";
import questionsSlice from "./questions";

export default combineReducers({
  credentials: credentialsSlice,
  spreadsheet: spreadsheetSlice,
  questions: questionsSlice,
});
